import { AboutView } from '../views';
export default AboutView;
